// @flow
import * as React from 'react';
import AttributeList from './AttributeList';

const META_FIELDS = {
  device_id: 'Device ID',
  locale: 'Locale',
  source: 'Source',
};

const PWR_META_FIELDS = {
  subject_id: 'Subject ID',
  ...META_FIELDS,
};

const CLIENT_META_FIELDS = {
  email: 'User Email',
  merchant_user_id: 'User ID',
  ...META_FIELDS,
};

const generateItems = (config: { [string]: string }, model: Ugc) => {
  return Object.keys(config).reduce((items, key) => {
    const label = config[key];
    const value = model[key] || '-';

    items.push({
      key: label,
      label: label,
      // $$FlowFixMe
      value: value,
    });
    return items;
  }, []);
};

type Props = {
  model: Ugc,
};

type MediaUgcMetaInfoProps = {
  model: Ugc,
  parentModel: Ugc,
};

const mediaUgcMetaInfo = (
  config: { [string]: string },
  props: MediaUgcMetaInfoProps
) => {
  const { model, parentModel } = props;

  // parent UGC is guaranteed to have
  const items = generateItems(config, parentModel);
  const [ugcId] = generateItems(
    {
      ugc_id: `${model.ugctype} ID`,
    },
    props.model
  );
  const [parentUgcId] = generateItems(
    {
      ugc_id: `${parentModel.ugctype} ID`,
    },
    parentModel
  );
  items.splice(1, 0, ugcId, parentUgcId);

  return <AttributeList items={items} className="mh4 mv3" />;
};

export const PwrUgcMetaInfo = (props: Props) => {
  const items = generateItems(PWR_META_FIELDS, props.model);
  const [ugcId] = generateItems(
    {
      ugc_id: `UGC ID`,
    },
    props.model
  );
  items.splice(1, 0, ugcId);
  return <AttributeList items={items} className="mh4 mv3" />;
};

export const ClientUgcMetaInfo = (props: Props) => {
  const items = generateItems(CLIENT_META_FIELDS, props.model);

  const [ugcId] = generateItems(
    {
      ugc_id: `${props.model.ugctype} ID`,
    },
    props.model
  );
  items.splice(1, 0, ugcId);
  return <AttributeList items={items} className="mh4 mv3" />;
};

export const PwrMediaUgcMetaInfo = (props: MediaUgcMetaInfoProps) =>
  mediaUgcMetaInfo(PWR_META_FIELDS, props);

export const ClientMediaUgcMetaInfo = (props: MediaUgcMetaInfoProps) =>
  mediaUgcMetaInfo(CLIENT_META_FIELDS, props);



// WEBPACK FOOTER //
// ./src/components/ContentSection/UgcMetaInfo.js